// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divisor-line {
  background: #ffc14d 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 2px;
  width: 75%;
  position: sticky;
  top: 90px;
  margin-top: -1rem;
  color: transparent;
}

.sideBar-container {
  background-color: #ffffff !important;
  position: fixed;
  height: 100% !important;
  cursor: pointer;
}
.sideBar-container li {
  list-style-type: none;
}

.btn-close {
  color: #000000;
  width: 15px;
}

.box-button-expanded {
  padding-bottom: 0px;
}

.sidenav---sidenav-nav---3tvij {
  background: #ffffff;
}
.sidenav---sidenav-nav---3tvij a {
  color: #000000;
}

.box-button-collapsed {
  padding-bottom: 200px;
}

.searchBarIsVisible {
  display: none !important;
}

.visible {
  padding: 1rem;
  margin-top: -1rem;
}
.visible .list-group-item {
  border-left: none;
  border-right: none;
  border-top: none;
}

.quickAccess-subtitle {
  margin-top: 1rem;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  background-color: rgb(120, 204, 210);
  border-radius: 1rem;
  padding-left: 5px;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}

.novisible {
  margin-left: -1.3rem !important;
  display: none;
}

.quickAccess-title {
  margin-top: 1rem;
  margin-left: 1rem;
  margin-bottom: 0rem;
  text-align: left;
  font: normal normal 800 16px sans-serif;
  font-family: "Lato", sans-serif !important;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  padding-left: 5px !important;
}

.searchBar-quickAccess {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.text-bottom-quickAccess {
  display: flex;
  justify-content: center;
  align-items: center;
}

.visible-qa-search {
  width: 80%;
  align-self: center !important;
  margin: 0px 15px;
}

.notlogged {
  margin-top: 0rem;
  z-index: 100;
}

.logged {
  margin-top: 0rem;
}

.search-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 28rem;
  position: absolute;
  bottom: 4rem;
}

.container-title-sutitle-non {
  display: none;
}

.button-non {
  display: none !important;
}

.search-logo-public {
  position: absolute;
  bottom: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quickAccess-title-sidebar {
  position: relative !important;
  right: 2rem;
  top: 35px;
}

.ultimate-items {
  background-color: white;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: auto;
  margin-bottom: 60px;
}

.ultimate-items-qa-mobile {
  background-color: red;
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: auto;
  margin-bottom: 60px;
}

.mma-logo {
  height: 40px;
  width: 80px;
  margin-bottom: 0.5rem;
  margin-left: 0.5rem;
  padding: 0;
}

.toggle-text {
  color: black !important;
  font-size: 12px !important;
  transform: rotate(-90deg);
  display: inline-block;
  margin-left: -140px;
  transform-origin: 100%;
}

.toggle-text-normal {
  color: #000000 !important;
  font-size: 25px !important;
  padding-top: 30px !important;
  padding: 20px;
}

.sideBar-container-nav {
  width: 380px;
}

.quickAccess-title {
  font-size: "Lato", sans-serif !important;
}

.nav-text {
  font-size: "Lato", sans-serif !important;
  color: rgb(255, 255, 255) !important;
}

@media (min-width: 1200px) {
  .sideBar-container {
    display: none !important;
  }
}
@media (max-width: 576px) {
  .sideBar-container {
    display: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/sideBar/sideBar.scss","webpack://./src/sass/layout/sideBar/sideBar.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,+CAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;ACFF;;ADIA;EACE,oCAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;ACDF;ADEE;EACE,qBAAA;ACAJ;;ADGA;EACE,cAAA;EACA,WAAA;ACAF;;ADEA;EACE,mBAAA;ACCF;;ADCA;EACE,mBAAA;ACEF;ADDE;EACE,cAAA;ACGJ;;ADAA;EACE,qBAAA;ACGF;;ADDA;EACE,wBAAA;ACIF;;ADFA;EACE,aAAA;EACA,iBAAA;ACKF;ADJE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;ACMJ;;ADHA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CErDK;EFsDL,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,0CEjEK;EFkEL,mBAAA;EACA,cAAA;EACA,UAAA;ACIF;;ADFA;EACE,+BAAA;EACA,aAAA;ACKF;;ADHA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;EACA,0CEhFK;EFiFL,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;ACMF;;ADJA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ACOF;;ADLA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ACQF;;ADNA;EACE,UAAA;EACA,6BAAA;EACA,gBAAA;ACSF;;ADPA;EACE,gBAAA;EACA,YAAA;ACUF;;ADRA;EACE,gBAAA;ACWF;;ADTA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;ACYF;;ADVA;EACE,aAAA;ACaF;;ADXA;EACE,wBAAA;ACcF;;ADZA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACeF;;ADbA;EACE,6BAAA;EACA,WAAA;EACA,SAAA;ACgBF;;ADdA;EACE,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;ECiBA,mBAAmB;AACrB;;AAEA;EDhBE,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;ECkBA,mBAAmB;AACrB;;AAEA;EDjBE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;ECmBA,UAAU;AACZ;;AAEA;EDjBE,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;ECmBA,sBAAsB;AACxB;;AAEA;EDjBE,yBAAA;EACA,0BAAA;EACA,4BAAA;ECmBA,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EDjBE,wCAAA;ECmBA,oCAAoC;AACtC;;AAEA;EACE;IACE,wBAAwB;EAC1B;ADhBF;ACkBA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.divisor-line {\n  background: #ffc14d 0% 0% no-repeat padding-box;\n  opacity: 1;\n  height: 2px;\n  width: 75%;\n  position: sticky;\n  top: 90px;\n  margin-top: -1rem;\n  color: transparent;\n}\n.sideBar-container {\n  background-color: #ffffff !important;\n  position: fixed;\n  height: 100% !important;\n  cursor: pointer;\n  li {\n    list-style-type: none;\n  }\n}\n.btn-close {\n  color: #000000;\n  width: 15px;\n}\n.box-button-expanded {\n  padding-bottom: 0px;\n}\n.sidenav---sidenav-nav---3tvij {\n  background: #ffffff;\n  a {\n    color: #000000;\n  }\n}\n.box-button-collapsed {\n  padding-bottom: 200px;\n}\n.searchBarIsVisible {\n  display: none !important;\n}\n.visible {\n  padding: 1rem;\n  margin-top: -1rem;\n  .list-group-item {\n    border-left: none;\n    border-right: none;\n    border-top: none;\n  }\n}\n.quickAccess-subtitle {\n  margin-top: 1rem;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: $Font;\n  letter-spacing: 0px;\n  background-color: rgb(120 204 210);\n  border-radius: 1rem;\n  padding-left: 5px;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  text-align: left;\n\n  font-family: $Font;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.novisible {\n  margin-left: -1.3rem !important;\n  display: none;\n}\n.quickAccess-title {\n  margin-top: 1rem;\n  margin-left: 1rem;\n  margin-bottom: 0rem;\n  text-align: left;\n  font: normal normal 800 16px sans-serif;\n  font-family: $Font;\n  font-weight: 800;\n  font-size: 16px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  padding-left: 5px !important;\n}\n.searchBar-quickAccess {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n.text-bottom-quickAccess {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.visible-qa-search{\n  width: 80%;\n  align-self: center !important;\n  margin: 0px 15px;\n}\n.notlogged {\n  margin-top: 0rem;\n  z-index: 100;\n}\n.logged {\n  margin-top: 0rem;\n}\n.search-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 28rem;\n  position: absolute;\n  bottom: 4rem;\n}\n.container-title-sutitle-non {\n  display: none;\n}\n.button-non {\n  display: none !important;\n}\n.search-logo-public {\n  position: absolute;\n  bottom: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.quickAccess-title-sidebar {\n  position: relative !important;\n  right: 2rem;\n  top: 35px;\n}\n.ultimate-items {\n  background-color: white;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 60px;\n}\n.ultimate-items-qa-mobile {\n  background-color: red;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 60px;\n}\n.mma-logo {\n  height: 40px;\n  width: 80px;\n  margin-bottom: 0.5rem;\n  margin-left: 0.5rem;\n  padding: 0;\n}\n\n.toggle-text {\n  color: black !important;\n  font-size: 12px !important;\n  transform: rotate(-90deg);\n  display: inline-block;\n  margin-left: -140px;\n  transform-origin: 100%;\n}\n\n.toggle-text-normal {\n  color: #000000 !important;\n  font-size: 25px !important;\n  padding-top: 30px !important;\n  padding: 20px;\n}\n\n.sideBar-container-nav {\n  width: 380px;\n}\n\n.quickAccess-title {\n  font-size: $Font;\n}\n\n.nav-text {\n  font-size: $Font;\n  color: $White !important;\n}\n\n@media (min-width: 1200px) {\n  .sideBar-container {\n    display: none !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .sideBar-container {\n    display: none !important;\n  }\n}\n",".divisor-line {\n  background: #ffc14d 0% 0% no-repeat padding-box;\n  opacity: 1;\n  height: 2px;\n  width: 75%;\n  position: sticky;\n  top: 90px;\n  margin-top: -1rem;\n  color: transparent;\n}\n\n.sideBar-container {\n  background-color: #ffffff !important;\n  position: fixed;\n  height: 100% !important;\n  cursor: pointer;\n}\n.sideBar-container li {\n  list-style-type: none;\n}\n\n.btn-close {\n  color: #000000;\n  width: 15px;\n}\n\n.box-button-expanded {\n  padding-bottom: 0px;\n}\n\n.sidenav---sidenav-nav---3tvij {\n  background: #ffffff;\n}\n.sidenav---sidenav-nav---3tvij a {\n  color: #000000;\n}\n\n.box-button-collapsed {\n  padding-bottom: 200px;\n}\n\n.searchBarIsVisible {\n  display: none !important;\n}\n\n.visible {\n  padding: 1rem;\n  margin-top: -1rem;\n}\n.visible .list-group-item {\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n\n.quickAccess-subtitle {\n  margin-top: 1rem;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  background-color: rgb(120, 204, 210);\n  border-radius: 1rem;\n  padding-left: 5px;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n\n.novisible {\n  margin-left: -1.3rem !important;\n  display: none;\n}\n\n.quickAccess-title {\n  margin-top: 1rem;\n  margin-left: 1rem;\n  margin-bottom: 0rem;\n  text-align: left;\n  font: normal normal 800 16px sans-serif;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 800;\n  font-size: 16px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  padding-left: 5px !important;\n}\n\n.searchBar-quickAccess {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.text-bottom-quickAccess {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.visible-qa-search {\n  width: 80%;\n  align-self: center !important;\n  margin: 0px 15px;\n}\n\n.notlogged {\n  margin-top: 0rem;\n  z-index: 100;\n}\n\n.logged {\n  margin-top: 0rem;\n}\n\n.search-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 28rem;\n  position: absolute;\n  bottom: 4rem;\n}\n\n.container-title-sutitle-non {\n  display: none;\n}\n\n.button-non {\n  display: none !important;\n}\n\n.search-logo-public {\n  position: absolute;\n  bottom: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quickAccess-title-sidebar {\n  position: relative !important;\n  right: 2rem;\n  top: 35px;\n}\n\n.ultimate-items {\n  background-color: white;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 60px;\n}\n\n.ultimate-items-qa-mobile {\n  background-color: red;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 60px;\n}\n\n.mma-logo {\n  height: 40px;\n  width: 80px;\n  margin-bottom: 0.5rem;\n  margin-left: 0.5rem;\n  padding: 0;\n}\n\n.toggle-text {\n  color: black !important;\n  font-size: 12px !important;\n  transform: rotate(-90deg);\n  display: inline-block;\n  margin-left: -140px;\n  transform-origin: 100%;\n}\n\n.toggle-text-normal {\n  color: #000000 !important;\n  font-size: 25px !important;\n  padding-top: 30px !important;\n  padding: 20px;\n}\n\n.sideBar-container-nav {\n  width: 380px;\n}\n\n.quickAccess-title {\n  font-size: \"Lato\", sans-serif !important;\n}\n\n.nav-text {\n  font-size: \"Lato\", sans-serif !important;\n  color: rgb(255, 255, 255) !important;\n}\n\n@media (min-width: 1200px) {\n  .sideBar-container {\n    display: none !important;\n  }\n}\n@media (max-width: 576px) {\n  .sideBar-container {\n    display: none !important;\n  }\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
